import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { PRODUCT_CARD_BASE_CLASSNAME } from './Constants';
import { createProductCard } from './ProductCard';
createComponents(".".concat(PRODUCT_CARD_BASE_CLASSNAME), createProductCard, NO_PATTERN_BUSINESS_LOGIC);
